export enum FeatureKeys {
  BUSINESS_INFORMATION = 'business-information',
  RESTAURANT_INFORMATION = 'restaurant-information',
  BANK_ACCOUNTS = 'bank-accounts',
  CREDIT_CARD = 'credit-card',
  RECURRING_PAYMENT_METHOD = 'recurring-payment-method',
  DASHBOARD = 'dashboard',
  OVERVIEW = 'overview',
  STAFF = 'staff',
  OFFICE = 'office',
  MARKETING = 'marketing',
  YOUR_WEEK = 'your-week',
  VIEW_OWN_TIMECARDS = 'view-own-timecards',
  VIEW_OTHER_EMPLOYEES = 'view-other-employees',
  EXPORT_TIMECARDS = 'export-timecards',
  AVAILABILITY = 'availability',
  TIME_OFF_REQUEST = 'time-off-request',
  RESEND_INVITE = 'resend-invite',
  DEACTIVATE_EMPLOYEE = 'deactivate-employee',
  REACTIVATE_EMPLOYEE = 're-activate-employee',
  PERSONAL_INFORMATION = 'personal-information',
  ASSIGNED_ROLES = 'assigned-roles',
  LOCATION_LEVEL_ACCESS = 'location-level-access',
  DOCUMENTS = 'documents',
  ROLES_PERMISSIONS = 'roles-permissions',
  VIEW_ORDER_DETAILS = 'view-order-details',
  REFUND = 'refund',
  SHARE_JOB = 'share-job',
  GENERAL_SETTINGS = 'general-settings',
  DEVICE_SETTINGS = 'device-settings',
  ONLINE_ORDERING = 'online-ordering',
  OWN_SHIFTS = 'own-shifts',
  DUPLICATE_SHIFT_BUTTON = 'duplicate-shift-button',
  RELEASE_OTHER_EMPLOYEES_SHIFT = 'release-other-employees-shift',
  RELEASE_SHIFTS = 'release-shifts',
  ASSIGN_TO_ANOTHER_EMPLOYEE_BUTTON = 'assign-to-another-employee-button',
  POOL = 'pool',
  POOL_VIEW = 'pool-view',
  APPROVE_REQUESTS = 'approve-requests',
  NET_SALES = 'net-sales',
  LABOUR_COST = 'labour-cost',
  COMPS_VOIDS = 'comps-voids',
  TOP_SELLERS = 'top-sellers',
  BREAK_VIOLATIONS = 'break-violations',
  CLOCK_IN = 'clock-in',
  LOGIN_WITHOUT_CLOCK_IN = 'login-without-clock-in',
  DEVICE_STATUS = 'device-status',
  TABLE = 'table',
  TABLE_STATUS = 'table-status',
  SWITCH_FLOORS = 'switch-floors',
  VIEW_SEATING_CAPACITY = 'view-seating-capacity',
  UPDATE = 'update',
  ADJUST = 'adjust',
  SERVICE_CHARGES = 'service-charges',
  CUSTOM_ITEM = 'custom-item',
  TAX_EXEMPT = 'tax-exempt',
  CHANGE_TABLE = 'change-table',
  CHANGE_SERVER = 'change-server',
  VOID_ORDER = 'void-order',
  SETTINGS_HAMBURGER = 'settings-hamburger',
  ORDERS_HUB_HAMBURGER = 'orders-hub-hamburger',
  RESTAURANT_TYPE_HAMBURGER = 'restaurant-type-hamburger',
  CASHDRAWER = 'cashdrawer',
  AIO_HELP_CENTER = 'aio-help-center',
  MY_DAY = 'my-day',
  Z_REPORT = 'z-report',
  EMPLOYEE_ATTENDANCE = 'employee-attendance',
  OTHER_STATIONS = 'other-stations',
  MY_STATION = 'my-station',
  LOGS = 'logs',
  ADJUST_STARTING_BALANCE = 'adjust-starting-balance',
  CLOSE_DRAWER = 'close-drawer',
  LOGIN = 'login',
  OTHER_TABLES = 'other-tables',
  VOID_ITEMS = 'void-items',
  EDIT_SERVICE_CHARGE = 'edit-service-charge',
  RESTAURANT = 'restaurant',
  LOCATION = 'location',
  RE_ASSIGN = 're-assign',
  CAN_BE_ASSIGNED_A_TASK = 'can-be-assigned-a-task',
  P2P_CHAT = 'p2p-chat',
  APPROVE_BUTTON = 'approve-button',
  CUSTOM_CATEGORY = 'custom-category',
  MENU = 'menu',
  CATEGORY = 'category',
  ITEM = 'Item',
  MODIFIER_GROUP = 'modifier-group',
  MODIFIER = 'modifier',
  MODIFIER_OPTION = 'modifier-option',
  TAGS_ALLERGENS = 'tags-allergens',
  SALES_TAX = 'sales-tax',
  COMPS = 'comps',
  SERVICE_CHARGE = 'service-charge',
  GUESTBOOK = 'guestbook',
  BRANDBOOK = 'brandbook',
  DEALS = 'deals',
  WEBSITE = 'website',
  SPOTLIGHTS = 'spotlights',
  CAMPAIGNS = 'campaigns',
  JOURNEYS = 'journeys',
  LOYALTY = 'loyalty',
  GIFT_CARDS = 'gift-cards',
  MY_ACCOUNT = 'my-account',
  EDIT_TIME_ENTRIES = 'edit-time-entries',
  APPROVE_REQUESTS_TAB = 'approve-requests-tab',
  REQUEST_TAB = 'request-tab',
  PROCESSED_TAB = 'processed-tab',
  MY_OWN_TAB = 'my-own-tab',
  SHIFTS = 'shifts',
  RELEASE_MANAGER_APPROVAL_REQUIRED = 'release-manager-approval-required',
  BID_ON_OPEN_SHIFTS = 'bid-on-open-shifts',
  EMPLOYEES = 'employees',
  DETAILS_BUTTON = 'details-button',
  TASKS = 'tasks',
  FILES = 'files',
  FOLDERS = 'folders',
  LOST_ITEMS = 'lost-items',
  FOUND_ITEMS = 'found-items',
  MARK_AS_RETRIEVED = 'mark-as-retrieved',
  PAY_SCHEDULES = 'pay-schedules',
  PAYROLL = 'payroll',
  ORDER_FORMS = 'order-forms',
  VIEW_OTHERS_PAY_STUBS = 'view-others-pay-stubs',
  VIEW_OWN_PAYSTUBS = 'view-own-paystubs',
  TENDERS = 'tenders',
  WEBSITE_TEMPLATES = 'website-templates',
  WEBSITE_BUILDER = 'website-builder',
  WEBSITE_SEO = 'website-seo',
  WEBSITE_ANNOUNCEMENTS = 'website-announcements',
  GUEST_SEGMENTS = 'guest-segments',
  GUEST_SPEND = 'guest-spend',
  INTEGRATIONS = 'integrations',
  REVIEW_MANAGEMENT = 'review-management',
  CASH_DRAWER = 'cash-drawer',
  TICKET = 'ticket',
  INGREDIENTS = 'ingredients',
  ORDERS = 'orders',
  RECIPES = 'recipes',
  INVOICES = 'invoices',
  STORAGE_AREAS = 'storage-areas',
  VENDORS = 'vendors',
  NON_INGREDIENTS = 'non-ingredients',
  INVENTORY_PREPARE_PREP_LIST = 'inventory-prepare-prep-list',
  INVENTORY_COOK_PREP_LIST = 'inventory-cook-prep-list',
  INVENTORY_WASTAGE_LOGS = 'inventory-wastage-logs',
  INVENTORY_VARIANCE = 'inventory-variance',
  INVENTORY_PLACED_ORDERS = 'inventory-placed-orders',
  EMPLOYEE_PAYOUT = 'employee-payout',
  FEATURED_MENU = 'featured-menu',
  FEATURED_ADS = 'featured-ads',
  CHART_OF_ACCOUNTS = 'chart-of-accounts',
  BILL_PAYMENTS = 'bill-payments',
  JOURNAL_ENTRY = 'journal-entry',
  RECONCILIATION = 'reconciliation',
  SALES_CONTROLLER = 'sales-controller',
  NOTIFICATIONS = 'notifications',
  INVENTORY_OVERVIEW = 'inventory-overview',
  AIO_CARE_OVERVIEW = 'aio-care-overview',
  ONBOARDING = 'onboarding',
  SETUP = 'setup',
  RECEIPT_SETTINGS = 'receipt-settings',
  BUSINESS_HOURS = 'business-hours',
  TIPS_POOLING = 'tips-pooling',
  ITEM_LEVEL_COMP = 'item-level-comp',
  TICKET_LEVEL_COMP = 'ticket-level-comp',
  HOUSE_DRAWER = 'house-drawer',
  NUGGET_CONFIGURATION = 'nugget-configuration',
}

export const RoleKeys = {
  BUDDY: 3,
  OWNER: 4,
  MANAGER: 5,
  SERVER: 6,
  COOK: 7,
  BARTENDER: 8,
  CASHIER: 9,
  BUSSER: 10,
  DELIVERY_SERVICE_DRIVER: 11,
  LINE_COOK: 12,
  SHIFT_OR_ASSISTANT_MANAGER: 13,
  BARBACK: 14,
  GM: 15,
  DISH_WASHER: 16,
  JANITORIAL: 17,
  CHEF: 18,
  ACCOUNTANT: 19,
} as const;

export enum FeatureName {
  REPORTS = 'Reports',
  SALES_SUMMARY = 'Sales Summary',
  NET_SALES = 'Net Sales',
  TIMECARDS = 'Timecards',
  PAYROLL_HISTORY = 'Payroll History',
  LABOR_REPORT = 'Labor report',
  OVERTIME_REPORT = 'Overtime report',
  EMPLOYEE_PRODUCTIVITY_REPORT = 'Employee productivity report',
  TIP_POOLING_REPORT = 'Tip pooling',
  BREAK_COMPLIANCE_REPORT = 'Break Compliance',
  MENU_SUMMARY_REPORT = 'Menu Summary',
  GIFT_CARD_REPORT = 'Gift card report',
  LOYALTY_REPORT = 'Loyalty report',
  DEALS_REPORT = 'Deals report',
  PAYROLL_SUMMARY = 'Payroll Summary',
  PERFORMANCE_SUMMARY = 'Performance Summary',
  THIRD_PARTY_ORDER_REPORT = 'Third Party Order Report',
  REFUND_REPORT = 'Refund Report',
  DISCOUNT_REPORT = 'Discount Report',
  MERCHANT_REPORT = 'Merchant Report',
  FORMS = 'Forms',
  OVERVIEW = 'Overview',
  DASHBOARD = 'Dashboard',
  INVOICE_MANAGEMENT = 'Invoice Management',
  PACKAGE_CONFIGURATION = 'Package Configuration',
  EMAIL_TEMPLATES = 'Email Templates',
  NUGGET_CONFIGURATION = 'Configuration',
  PAYMENT_CONFIGURATION = 'Payment Configuration',
  EMAIL_INBOX = 'Email Inbox',
  CALENDAR = 'Calendar',
}
